export function stringToBoolean(value: unknown) {
  return value === true || value === 'true'
}

export function stringToNumber(value: unknown) {
  if (typeof value === 'number') return Number.isFinite(value) ? value : undefined
  if (typeof value !== 'string') return undefined
  const trimmed = value.trim()
  if (!trimmed) return undefined
  const parsed = Number(trimmed)
  return Number.isFinite(parsed) ? parsed : undefined
}

export function stringToList(value: unknown) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean)
  }

  if (typeof value !== 'string') return []

  return value
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean)
}

export function omitEmptyValues<T extends Record<string, unknown>>(value: T) {
  return Object.fromEntries(
    Object.entries(value).filter(([, entry]) => {
      if (entry === '' || entry === null || entry === undefined) return false
      if (Array.isArray(entry) && entry.length === 0) return false
      return true
    }),
  ) as Partial<T>
}
